angular.module('dpw.components')
    /**
     * @ngdoc directive
     * @name dpwDateValidate
     * @restrict A
     * @requires ngModel
     * @param {String} format - Date format used in MomentJS.
     * @description
     * Validate if the date format of input is valid.
     * @example
     * <input ng-model="$ctrl.someDate" dpw-date-validate />
     * <input ng-model="$ctrl.someDate" dpw-date-validate format="YYYYMMDD" />
     */
    .directive('dpwDateValidate', [function () {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function (scope, element, attrs, ngModel) {

                    ngModel.$parsers.push(function (value) {

                        ngModel.$setValidity('dateValid', moment(value, (attrs.format || "YYYYMMDD"), true).isValid());

                        return value;
                    });
                }
            };
        }]
    );